import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../constants/Properties'
import { setConfigurationModalBySteps, hideConfigurationModal, reloadConfigurationModal } from '../actions/generalActions'
import { addReceiptLineWithOptionalParams, removeReceiptline, removeQuantity } from '../actions/receiptActions'
import { toggleKeyboard } from '../actions/layoutActions'
import { getArticle, getArticleDescription, getTranslation } from '../actions/dataActions'
import Ink from 'react-ink';
import ConfigurationModalStepButton from './ConfigurationModalStepButton'
import ConfigurationModalValueButton from './ConfigurationModalValueButton'
import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import * as rl from '../models/ReceiptLine'
import * as general from '../constants/General'
import { getSelectedLine } from '../functions/ReceiptFunctions'

class ConfigurationModal extends Component {
  constructor(props) {
    super(props); this.configurationStepClick = this.configurationStepClick.bind(this);
    this.configurationValueClick = this.configurationValueClick.bind(this);
    this.closeWindow = this.closeWindow.bind(this);
    this.addConfiguration = this.addConfiguration.bind(this);
    this.findNextEmptyStep = this.findNextEmptyStep.bind(this);
    this.addConfigurationStepValue = this.addConfigurationStepValue.bind(this);
    this.processConfigurationChoice = this.processConfigurationChoice.bind(this);
    this.deleteConfigurationStep = this.deleteConfigurationStep.bind(this);
  }

  addConfiguration(lastItemChoosen = false, allowMultiple = false, currentConfigId = null) {
    let currentConfiguration = [];
    let duplicateSteps = [];
    let lastOrder = -1;

    this.props.steps.map(step => {

      if (step.order === lastOrder)
        duplicateSteps.push(step);

      lastOrder = step.order;

      if (step.showstep) {
        step.selectedValues.map(value => {
          currentConfiguration.push({
            ConfigurationStepId: value.ArticleConfigurationStepId,
            ConfigurationStepValueId: value.ArticleConfigurationStepValueId,
            ConfigurationStepValueDescription: value.Description,
            ParentConfigurationStepValueId: value.ParentArticleConfigurationStepValueId
          });
          return '';
        });
      }
      return '';
    });

    duplicateSteps.map(step => {
      this.props.steps.splice(this.props.steps.indexOf(step), 1);
      return '';
    })

    // Validate that all required configuration steps have at least one selection
    // Skip validation for steps that allow multiple selections (they can be empty)
    const configIds = [...new Set(this.props.steps
      .filter(step => step.showstep && !step.allowMultiple)
      .map(step => step.configId))];

    for (const configId of configIds) {
      const stepsForConfig = this.props.steps.filter(step =>
        step.showstep && step.configId === configId && !step.allowMultiple
      );
      const hasSelectedValue = stepsForConfig.some(step =>
        step.selectedValues && step.selectedValues.length > 0
      );

      if (!hasSelectedValue) {
        // Find the first step for this configId and make it active
        const firstStepForConfig = stepsForConfig
          .sort((a, b) => a.order - b.order)[0];

        if (firstStepForConfig) {
          let configuration = [...this.props.steps];
          configuration.forEach(step => {
            step.active = step.id === firstStepForConfig.id;
          });
          this.props.setConfigurationModalBySteps(configuration);
          return false; // Don't proceed with saving
        }
      }
    }

    // Check if there are any empty steps with different configIds (excluding allowMultiple steps)
    const nextEmptyStep = this.findNextEmptyStep();

    // Only close modal if all required steps are filled and there are no more empty steps
    const allRequiredStepsFilled = configIds.every(configId => {
      const stepsForConfig = this.props.steps.filter(step =>
        step.showstep && step.configId === configId && !step.allowMultiple
      );
      return stepsForConfig.some(step =>
        step.selectedValues && step.selectedValues.length > 0
      );
    });

    if (nextEmptyStep && !lastItemChoosen) {
      // Navigate to the next empty step
      let configuration = [...this.props.steps];
      configuration.forEach(step => {
        step.active = step.id === nextEmptyStep.id;
      });
      this.props.setConfigurationModalBySteps(configuration);
      return false;
    }

    // Only close if all required steps are filled or lastItemChoosen
    if (allRequiredStepsFilled && lastItemChoosen) {
      const inputquantitynegative = this.props.inputquantitynegative;
      const input = parseFloat(this.props.inputquantity, 10);

      let quantity = 1;
      let salesPrice = this.props.article.SalesPrice;


      if (this.props.article.OpenPrice) {
        salesPrice = input;
      }
      else {
        if (input > 0) {
          quantity = parseFloat(input);
        }
        if (inputquantitynegative) {
          quantity *= -1;
        }
      }

      let configurationedit = false;
      let isValidLine = this.props.lineid && this.props.lineid > 0;
      if (isValidLine) {
        configurationedit = true;
        this.props.lines.map(l => {
          if (l.id === this.props.lineid) {
            quantity = l.quantity;
            salesPrice = l.openprice;
          }
          return '';
        })


      }

      const rlParam = rl.Get();
      rlParam.Text = this.props.getArticleDescription(this.props.article);
      rlParam.Price = salesPrice;
      rlParam.Quantity = quantity;
      rlParam.ItemId = this.props.article.ArticleId;
      rlParam.LineType = types.ARTICLE_LINE;
      rlParam.Editable = true;
      const configurationCount = currentConfiguration.filter(config => config.ParentConfigurationStepValueId === 0).length;
      const rlParamOptional = rl.GetOptional();
      rlParamOptional.Configuration = currentConfiguration;
      rlParamOptional.ConfigurationEdit = configurationedit;
      fetch(`${general.API_URL_GET_SYSTEM_SETTING_BY_KEY}AddConfigurationPerArticle`, {
        method: 'GET'
      }).then(response => response.json())
        .then(json => {
          let addConfigurationPerArticle = json ? json.Value : "false"
          if (quantity !== 1 && configurationCount === 1 && addConfigurationPerArticle === 'true') {
            rlParam.Quantity = 1;
            if (isValidLine) {
              this.props.removeQuantity(this.props.lineid);
            }
          } else {
            if (isValidLine) {
              this.props.removeReceiptline(this.props.lineid);
            }
          }

          this.props.addReceiptLineWithOptionalParams(rlParam, rlParamOptional);
          if (allowMultiple && (this.props.lineid && (this.props.lineid && this.props.lineid > 0))) {
            this.props.reloadConfigurationModal(this.props.lineid, currentConfigId);
          } else {
            this.props.hideConfigurationModal();
          }

          return true;
        }
        );
    }
    return false;
  }


  findNextEmptyStep() {
    // Get all unique configIds from steps that should be shown
    const configIds = [...new Set(this.props.steps
      .filter(step => step.showstep)
      .map(step => step.configId))];

    // Sort steps by order
    const sortedSteps = this.props.steps
      .filter(step => step.showstep)
      .sort((a, b) => a.order - b.order);

    // Find the first configId that has no selected value
    for (const configId of configIds) {
      const stepsForConfig = sortedSteps.filter(step => step.configId === configId);
      const hasSelectedValue = stepsForConfig.some(step => step.selectedValueId && step.selectedValueId > 0);

      if (!hasSelectedValue) {
        // Find the first step for this configId that is NOT already active
        const firstStep = stepsForConfig[0];
        if (firstStep && !firstStep.active) {
          return firstStep;
        }
      }
    }

    return null;
  }

  addConfigurationStepValue(stepValues, stepValue) {
    let found = false;
    stepValues.map(v => {
      if (v.ArticleConfigurationStepId === stepValue.ArticleConfigurationStepId
        && v.ParentArticleConfigurationStepValueId === stepValue.ParentArticleConfigurationStepValueId) {
        found = true;
        v.ArticleConfigurationStepValueId = stepValue.ArticleConfigurationStepValueId;
      }
      return '';
    });

    if (!found) {
      stepValues.push(stepValue);
    }
  }

  configurationStepClick(id) {
    let configuration = [];

    this.props.steps.map(step => {

      if (step.showstep) {
        step.active = step.id === id;
      }

      if (step.active) {
        step.selectedValues = [];
      }

      if (step.parentstepid !== id) {
        configuration.push(step);
      }
      return '';
    });

    this.props.setConfigurationModalBySteps(configuration);
  }

  configurationValueClick(stepId, valueId) {
    let configuration = [];

    let currentStep = null;
    let currentValue = null;

    this.props.steps.forEach(step => {
      if (step.id === stepId) {
        step.values.forEach(value => {
          if (value.ArticleConfigurationStepValueId === valueId) {
            currentStep = step;
            currentValue = value;
          }
        });
      }

      configuration.push(step);
    });

    if (currentStep !== null
      && currentValue !== null) {
      if (currentValue.Type === 300) { //FreeInput
        this.props.toggleKeyboard(true,
          null,
          '',
          this.processConfigurationChoice,
          [configuration, currentStep, currentValue]);
      } else {
        this.processConfigurationChoice(currentValue.Description, configuration, currentStep, currentValue);
      }
    }
  }

  processConfigurationChoice(description, configuration, step, value) {
    const selectedValue = {
      ParentArticleConfigurationStepValueId: 0,
      ArticleConfigurationStepValueId: value.ArticleConfigurationStepValueId,
      Description: `${step.stepdescription}: ${description}`,
      ArticleConfigurationStepId: step.configId,
      AllowMultiple: step.allowMultiple
    }
    step.selectedValueId = value.ArticleConfigurationStepValueId;

    if (step.parentstepid !== undefined) {
      configuration.map(config => {
        if (config.id === step.parentstepid) {
          selectedValue.Description = `${step.stepdescription}: ${value.Description}`;
          selectedValue.ParentArticleConfigurationStepValueId = config.selectedValueId;
          selectedValue.ArticleConfigurationStepId = step.id;

          this.addConfigurationStepValue(configuration[0].selectedValues, selectedValue);
        }
        return '';
      })
    } else {
      this.addConfigurationStepValue(step.selectedValues, selectedValue);
    }

    // If allowMultiple is true, handle multiple selections
    if (step.allowMultiple) {
      // Deactivate the current step since it's been completed
      step.active = false;
      step.showstep = true; // Keep showing it in the sidebar

      // Check if there's already an empty step with the same configId
      let existingEmptyStep = null;
      let latestOrder = -1;

      configuration.forEach(configStep => {
        if (configStep.configId === step.configId &&
          configStep.selectedValueId === 0 &&
          configStep.order > latestOrder) {
          existingEmptyStep = configStep;
          latestOrder = configStep.order;
        }
      });

      // If no empty step exists, create a new one
      if (!existingEmptyStep) {
        const newStep = {
          id: Date.now(), // Generate unique ID
          order: step.order + 0.01,
          description: step.description,
          stepdescription: step.stepdescription,
          selectedValueId: 0,
          active: true, // Make it active
          values: step.values, // Same values as the original step
          selectedValues: [],
          showstep: true,
          parentstepid: step.parentstepid,
          allowMultiple: step.allowMultiple,
          configId: step.configId
        };

        configuration.push(newStep);
      } else {
        // Activate the existing empty step
        existingEmptyStep.active = true;
      }
    }

    if (value.ArticleId > 0) {
      const article = this.props.getArticle(value.ArticleId);
      if (article !== null) {
        let newOrder = step.order + 0.1;
        article.Configurations.map(articleValueStep => {
          this.props.configurationsteps.map(articleValueRealStep => {

            if (articleValueRealStep.ArticleConfigurationStepId === articleValueStep.ConfigurationStepId) {
              configuration.push({
                id: articleValueRealStep.ArticleConfigurationStepId,
                order: newOrder,
                description: step.description,
                stepdescription: articleValueRealStep.Description,
                selectedValueId: articleValueStep.DefaultValueId,
                active: false,
                values: articleValueRealStep.ArticleConfigurationStepValues,
                selectedValues: [],
                showstep: false,
                parentstepid: step.id
              });
            }
            return '';
          })
          newOrder += 0.1;
          return '';
        })
      }
    }

    configuration.sort(function (a, b) { return a.order - b.order });

    let setNextActive = false;
    let lastItemChoosen = false;

    // If allowMultiple is true, don't automatically move to next step
    if (!step.allowMultiple) {
      configuration.map(step => {
        if (setNextActive) {
          step.active = true;
          setNextActive = false;
        }

        if (step.active) {
          if (step.selectedValueId > 0) {
            setNextActive = true;
            step.active = false;

            if (configuration[configuration.length - 1] === step) {
              lastItemChoosen = true;
            }
          }
        }

        return '';
      })
    }

    if (((!this.props.lineid || (this.props.lineid && this.props.lineid < 0)) && setNextActive) || lastItemChoosen) {
      if (this.addConfiguration(lastItemChoosen, step.allowMultiple, step.configId)) {
        return;
      }
    }

    this.props.setConfigurationModalBySteps(configuration);
  }

  closeWindow() {
    this.props.hideConfigurationModal();
  }

  scrollUp() {
    document.getElementById('configurationModalValuesContent').scrollTop -= document.getElementById('configurationModalValuesContent').clientHeight;
  }

  scrollDown() {
    document.getElementById('configurationModalValuesContent').scrollTop += document.getElementById('configurationModalValuesContent').clientHeight;
  }

  deleteConfigurationStep(stepId) {
    let configuration = [...this.props.steps];

    // Find the step to delete
    const stepToDelete = configuration.find(step => step.id === stepId);
    if (!stepToDelete) return;

    // Remove the step from configuration
    configuration = configuration.filter(step => step.id !== stepId);

    // If there are no more steps with the same configId, create a new empty one
    const stepsWithSameConfigId = configuration.filter(step =>
      step.configId === stepToDelete.configId && step.showstep
    );

    if (stepsWithSameConfigId.length === 0) {
      // Create a new empty step
      const newStep = {
        id: Date.now(),
        order: stepToDelete.order,
        description: stepToDelete.description,
        stepdescription: stepToDelete.stepdescription,
        selectedValueId: 0,
        active: true,
        values: stepToDelete.values,
        selectedValues: [],
        showstep: true,
        parentstepid: stepToDelete.parentstepid,
        allowMultiple: stepToDelete.allowMultiple,
        configId: stepToDelete.configId
      };
      configuration.push(newStep);
    } else {
      // If no step is currently active, make the first one active
      const hasActiveStep = configuration.some(step => step.active);
      if (!hasActiveStep) {
        const firstStep = stepsWithSameConfigId
          .sort((a, b) => a.order - b.order)[0];
        if (firstStep) {
          firstStep.active = true;
        }
      }
    }

    // Sort by order
    configuration.sort((a, b) => a.order - b.order);

    this.props.setConfigurationModalBySteps(configuration);
  }

  render() {
    const steps = [];
    let selectedStep = { values: [] };
    this.props.steps.map(step => {
      if (step.active) {
        selectedStep = step;
      }

      if (step.showstep) {
        steps.push(step);
      }
      return '';
    });

    let article = this.props.article;
    if (!article) {
      article = { Description: '' };
    }


    // let deleteButton;
    // deleteButton = (
    //   <button className="configurationModalDelete" onClick={this.deleteConfigurations}>
    //     {this.props.getTranslation(resource.DELETE_ALL)}
    //     <Ink />
    //   </button>);
    const isEditingExistingLine = this.props.lineid && this.props.lineid > 0;
    let saveButton;
    let isLastStep = false;
    if (steps.length > 0 && selectedStep.id === steps[steps.length - 1].id) {
      isLastStep = true;
    }

    if (selectedStep.allowMultiple) {
      saveButton = (
        <button
          className="configurationModalSave"
          onClick={() =>
            this.addConfiguration(
              isLastStep, // lastItemChoosen: true only if last step
              selectedStep.allowMultiple,
              selectedStep.configId
            )
          }
        >
          {this.props.getTranslation(resource.CONTINUE)}
          <Ink />
        </button>);
    }


    let currentstepdescription = selectedStep.description;
    if (selectedStep.description !== selectedStep.stepdescription) {
      currentstepdescription = `${currentstepdescription} - ${selectedStep.stepdescription}`;
    }

    // 300 is freetext, when selectedStep is a free text field, show keyboard.
    if (this.props.show && selectedStep.values && selectedStep.values.length === 1 && selectedStep.values[0].Type === 300) {
      this.configurationValueClick(selectedStep.id, selectedStep.values[0].ArticleConfigurationStepValueId);
    }

    return (
      <Modal className="configurationModal"
        contentLabel=""
        id="reactModal"
        isOpen={this.props.show}
        style={properties.configurationModalStyle}
      >
        <div className="configurationModalContent">
          <div className="configurationModalSideBar">
            <label className="configurationModalProductName">{this.props.getArticleDescription(article)}</label>
            <br />
            <br />
            {
              steps.map(step =>
                <div key={step.id} className="configuration-step-container">
                  <ConfigurationModalStepButton
                    id={step.id}
                    stepDescription={step.stepdescription}
                    stepValues={
                      // Map selectedValues to only show the description part
                      step.selectedValues.map(v => ({
                        ...v,
                        Description: v.Description.includes(': ') ? v.Description.split(': ').slice(1).join(': ') : v.Description
                      }))
                    }
                    callback={isEditingExistingLine ? null : this.configurationStepClick}
                    disabled={isEditingExistingLine}
                  />
                  {step.allowMultiple && step.selectedValues && step.selectedValues.length > 0 && !isEditingExistingLine && (
                    <button
                      className="configurationModalStepDeleteButton"
                      onClick={() => this.deleteConfigurationStep(step.id)}
                      title="Delete this configuration"
                    >
                      <i className="icon remove" />
                      <Ink />
                    </button>
                  )}
                </div>
              )
            }
          </div>
          <div className="configurationModalValues">
            <button className="configurationModalClose" onClick={this.closeWindow}>
              <i className="icon remove" />
              <Ink />
            </button>
            <button className="configurationModalUp" onClick={this.scrollUp}>
              <i className="icon angle up huge" />
              <Ink />
            </button>
            <button className="configurationModalDown" onClick={this.scrollDown}>
              <i className="icon angle down huge" />
              <Ink />
            </button>
            <div id="configurationModalValuesContent" className="configurationModalValuesContent">
              <label className="configurationModalStep">{currentstepdescription}</label>
              <br />
              <br />
              {
                selectedStep.values.map(value => {
                  // Check if this value is selected in another step with the same configId
                  const selectedInOtherStep = this.props.steps.some(
                    step =>
                      step.configId === selectedStep.configId &&
                      step.id !== selectedStep.id &&
                      step.selectedValues.some(
                        v => v.ArticleConfigurationStepValueId === value.ArticleConfigurationStepValueId
                      )
                  );

                  return (
                    <ConfigurationModalValueButton
                      key={value.ArticleConfigurationStepValueId}
                      id={value.ArticleConfigurationStepValueId}
                      stepId={selectedStep.id}
                      description={value.Description}
                      selected={selectedStep.selectedValueId === value.ArticleConfigurationStepValueId}
                      callback={this.configurationValueClick}
                      selectedInOtherStep={selectedInOtherStep}
                    />
                  );
                })
              }
            </div>
            <div className="configurationModalButtons">
              {saveButton}
              {/* {deleteButton} */}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

ConfigurationModal.propTypes = {
}
function mapStateToProps(state) {
  return {
    steps: state.generalState.modal.configurationModal.configurationSteps,
    show: state.generalState.modal.configurationModal.show,
    article: state.generalState.modal.configurationModal.article,
    lineid: state.generalState.modal.configurationModal.lineid,
    articles: state.generalState.articles,
    configurationsteps: state.generalState.configurationsteps,
    lines: state.receiptState.receipt.lines,
    inputquantitynegative: state.receiptState.input.inputquantitynegative,
    inputquantity: state.receiptState.input.inputquantity,
    culture: state.layoutState.language.culture
  }
}

export default connect(mapStateToProps, {
  setConfigurationModalBySteps,
  hideConfigurationModal,
  reloadConfigurationModal,
  addReceiptLineWithOptionalParams,
  removeReceiptline,
  removeQuantity,
  getArticle,
  getArticleDescription,
  getTranslation,
  toggleKeyboard,
  getSelectedLine
})(ConfigurationModal)



// WEBPACK FOOTER //
// src/components/ConfigurationModal.jsx